<template>
    <div>
        <slot>暂无数据！</slot>
        
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    methods: {
        onClick() {}
    },
    components: {}
};
</script>

<style lang='scss' scoped>
</style>
